export default __webpack_public_path__ + "static/media/icon-add.e3da364b.svg";